// extracted by mini-css-extract-plugin
export default {"btnContainer":"RegestrationBtn_btnContainer__ipxqw","btn":"RegestrationBtn_btn__DHYMN"};